import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output, HostBinding, OnDestroy, ViewChild } from "@angular/core";
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode } from "../../services/IWebShopService";
import { CoreLogService } from "../../services/log.service";
import { UserHelperService } from "../../services/userHelper.service";
import { RegetrationTab } from "../../shared/contentTypes";
import { RouterHelperService } from "../../services/routerHelper.service";
import { Router } from "@angular/router";
import { MatCheckboxChange } from "@angular/material";
import { CustomerInputFieldViewModel, WebshopOrderDataViewModel, FurtherAddressViewModel, deliveryTypes } from "../../shared/models/webshop.model";
import { CoreLanguageService } from "../../services/language.service";
import Utils from "../../shared/utils";
import { KeyValueBase } from "../../shared/models/interface";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { InvalidDeliveryAddressComponent } from "../../modalDialogs/invalidDeliveryAddress/invalidDeliveryAddress.component";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { MatDialog } from "@angular/material";
import { ErrorDialogComponent } from "../../modalDialogs";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LocalKeys, StorageHive } from "../../services/valueStorage.service";
import { CoreCOMService } from "../../services/com.service";
import { env } from '../../../../environments/environment';
import { DynamicFormFieldsComponent } from "../../directives";
import { FormGroup } from "@angular/forms";
import { SnackBarService } from "../../services/snackBar.service";

export interface IAddress {
  zip_code: string;
  city: string;
  address: string;
  country?: string;
}

@Component({
  selector: "ya-customerData",
  templateUrl: "./customerData.component.html",
  styleUrls: ["./customerData.component.scss"],
  providers: [], // CustomerDataService
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerDataComponent implements OnInit, OnDestroy {
  @HostBinding("class") class = "ya-typography mat-tab-group";
  @Output() onContinue = new EventEmitter<boolean>(); // TODO Momentan nur um vorherige Funktionalität zu erhalten.
  @ViewChild("billingFormComponent") billingFormComponent: DynamicFormFieldsComponent;
  @ViewChild("registeredUserDeliveryFormComponent") registeredUserDeliveryFormComponent: DynamicFormFieldsComponent;
  @ViewChild("guestDeliveryFormComponent") guestDeliveryFormComponent: DynamicFormFieldsComponent;

  private webshopOrderDataViewModelChangedAfterUserLoginStatusChangedSubscription: Subscription;
  private _destroy$: Subject<void> = new Subject<void>();

  public customerInputFieldViewModels: CustomerInputFieldViewModel[];
  public addressInputFieldViewModels: CustomerInputFieldViewModel[];

  public webshopOrderDataViewModel: WebshopOrderDataViewModel;

  private deliveryAddressViewModel: FurtherAddressViewModel;
  public newDeliveryAddressViewModel: FurtherAddressViewModel;
  public guestDeliveryAddressViewModel: FurtherAddressViewModel;

  public isRegistered: boolean = false;
  public guestDeliveryAddressLabel: string = "";
  public showBillingInfo: boolean | null;
  public deliveryAddressList: KeyValueBase[] = null;
  public panelOpenState = false;
  public deliveryAddressId: string;
  public WebShopMode = WebShopMode;
  public isSmallView: boolean = false;
  public password: string;
  public serviceId: number;

  public DELIVERY_ADDRESS_ID = "-1";
  public BILLING_ADDRESS_ID = "0";

  constructor(private _webShopService: WebShopService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreComService: CoreCOMService
    , private _userHelperService: UserHelperService
    , private _routerHelperService: RouterHelperService
    , private _router: Router
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _coreLanguageService: CoreLanguageService
    , private _iosHelperService: IOSHelperService
    , private _MatDialog: MatDialog
    , private _snackBarService: SnackBarService
    , _mainnavService: MainnavService) {
    const me = this;
    me.isSmallView = _mainnavService.viewType === ViewType.Small;
  }

  ngOnInit() {
    const me = this;
    me.serviceId = me._webShopService.getServiceMode();
    me.webshopOrderDataViewModelChangedAfterUserLoginStatusChangedSubscription = me._webShopService.webshopOrderDataViewModelChangedAfterUserLoginStatusChangedObserver.subscribe((_) => {
      me._initializeCustomerData();
      me.PushChanges();
      me.initializeFormData();
    });

    me.handleCountryChange();
    me._initializeCustomerData();
    me.initializeFormData();
    me.PushChanges();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.webshopOrderDataViewModelChangedAfterUserLoginStatusChangedSubscription) {
      me.webshopOrderDataViewModelChangedAfterUserLoginStatusChangedSubscription.unsubscribe();
    }
    me._destroy$.next();
    me._destroy$.complete();
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("WebshopComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  // region Getters

  /** die Lieferadresse wird für die Bestellung benötigt */
  public get needDeliveryAddress(): boolean {
    const me = this;
    let serviceNeedDeliveryAddress = (
      me.serviceId === WebShopMode.Delivery ||
      me.serviceId === WebShopMode.DeliveryGroup ||
      me.serviceId === WebShopMode.Retail
    );
    // Webgutscheine brauchen lieferadresse nur bei Postversand
    if (!serviceNeedDeliveryAddress && me.serviceId === WebShopMode.Webvoucher) {
      serviceNeedDeliveryAddress = me._webShopService.shippingCartItems.filter(item => item.delivery_type == deliveryTypes.post).length > 0;
    }
    return serviceNeedDeliveryAddress;
  }

  /** Returns the currently active dynamic form component based on context */
  private get currentDynamicFormComponent(): DynamicFormFieldsComponent | null {
    const me = this;
    if (me.showBillingInfo) {
      return me.billingFormComponent;
    } else if (me.isRegistered) {
      return me.registeredUserDeliveryFormComponent;
    } else {
      return me.guestDeliveryFormComponent;
    }
  }

  public get dynamicDataInputForm(): FormGroup | null {
    const form = this.currentDynamicFormComponent && this.currentDynamicFormComponent.formGroup ?
      this.currentDynamicFormComponent.formGroup : null;
    return form;
  }


  /** Initial data for billing for guests and registered users*/
  public get billingFormInitialData(): { [key: string]: string | number | null } {
    return this.createFormInitialData(
      this.webshopOrderDataViewModel,
      this.customerInputFieldViewModels
    );
  }

  /** Initial data for registered user delivery address form*/
  public get registeredUserDeliveryFormInitialData(): { [key: string]: string | number | null } {
    return this.createFormInitialData(
      this.newDeliveryAddressViewModel,
      this.addressInputFieldViewModels
    );
  }

  /** Initial data for guest delivery address form*/
  public get guestDeliveryFormInitialData(): { [key: string]: string | number | null } {
    return this.createFormInitialData(
      this.guestDeliveryAddressViewModel,
      this.addressInputFieldViewModels
    );
  }

  // region Initialization

  private _initializeCustomerData() {
    const me = this;
    me.webshopOrderDataViewModel = me._webShopService.webshopOrderDataViewModel
      ? me._webShopService.webshopOrderDataViewModel
      : new WebshopOrderDataViewModel();
    me.customerInputFieldViewModels = me._webShopService.customerInputFieldViewModels;
    me.deliveryAddressViewModel = me._webShopService.getDelivaryAddress();
    if (!me.deliveryAddressViewModel.id) {
      me.newDeliveryAddressViewModel = me.deliveryAddressViewModel;
    } else {
      me.newDeliveryAddressViewModel = new FurtherAddressViewModel();
      me.newDeliveryAddressViewModel.zip_code = me.deliveryAddressViewModel.zip_code;
      me.newDeliveryAddressViewModel.city = me.deliveryAddressViewModel.city;
    }
    me.isRegistered = me._userHelperService.IsRegistered;
    if (me.isRegistered) {
      if (me.needDeliveryAddress) {
        const needBillingInfoValidation = true;
        me.showBillingInfo = needBillingInfoValidation;
        me.addressInputFieldViewModels = me._webShopService.getAddressInputFields();
        me.createFurtherAddressList(me._webShopService.webshopOrderDataViewModel);
      } else {
        me.showBillingInfo = true;
      }
    } else {
      me.initializeGuestData().then(() => {
        me.PushChanges();
      });
    }
  }

  /** Initializes guest user data */
  private async initializeGuestData() {
    const me = this;
    me.showBillingInfo = true;
    //load cached adreeses for guest
    await me.loadBillingAddressFromCache();

    if (me.isOrderDelivery) {
      // check if guestDeliveryAddressViewModel already has data
      if (!me.guestDeliveryAddressViewModel) {
        // try to load from cache
        const cachedDeliveryAddress = await me.loadDeliveryAddressFromStorage();
        if (cachedDeliveryAddress) {
          me.guestDeliveryAddressViewModel = me.createFurtherAddressFromStorage(cachedDeliveryAddress);
        } else {
          me.guestDeliveryAddressViewModel = new FurtherAddressViewModel();
        }
      }
      me.getGuestDeliveryAddressLabel();
      me.addressInputFieldViewModels = me._webShopService.getAddressInputFields();
    } else {
      if (me.needDeliveryAddress) {
        if (!me.deliveryAddressViewModel.id) {
          me.guestDeliveryAddressViewModel = me.deliveryAddressViewModel;
        } else {
          me.guestDeliveryAddressViewModel = new FurtherAddressViewModel();
        }
        me.addressInputFieldViewModels = me._webShopService.getAddressInputFields();
      }
    }

    me.verifyAndAssignGuestDeliveryAddress();
  }

  /**Initializes form with existing data */
  private initializeFormData(): void {
    const me = this;
    if (!me.currentDynamicFormComponent) return;
    let dataToLoad: WebshopOrderDataViewModel | FurtherAddressViewModel | null = null;
    let isFurtherAddress = false;

    if (me.showBillingInfo && !me.isRegistered) {
      // Billing info for guests
      dataToLoad = me.webshopOrderDataViewModel;
      me.deliveryAddressId = me.BILLING_ADDRESS_ID; // set default to billing address
      isFurtherAddress = false;
    } else if (me.showBillingInfo && me.isRegistered) {
      // Billing info for registered users
      dataToLoad = me.webshopOrderDataViewModel;
      isFurtherAddress = false;
    } else if (!me.showBillingInfo && me.isRegistered && me.deliveryAddressId === me.DELIVERY_ADDRESS_ID) {
      // New delivery address for registered user
      dataToLoad = me.newDeliveryAddressViewModel;
      isFurtherAddress = true;
    } else if (!me.showBillingInfo && !me.isRegistered) {
      // Delivery address for guests
      dataToLoad = me.guestDeliveryAddressViewModel;
      isFurtherAddress = true;
    }

    if (dataToLoad) {
      // Load data into FormGroup
      const formData: { [key: string]: string | number | null } = {};
      const fieldModels = isFurtherAddress ? me.addressInputFieldViewModels : me.customerInputFieldViewModels;

      if (fieldModels) {
        fieldModels.forEach(field => {
          const value = dataToLoad[field.fieldName];
          formData[field.fieldName] = value || '';
        });
        me.currentDynamicFormComponent.formGroup.patchValue(formData);
      }
      // Apply disabled states
      me.applyFieldDisabledStates(isFurtherAddress);
    }
    me.PushChanges();
  }

  /** Fires for interactive country selection and the Retail self-heal path (WebShopService.resolveRetailDeliveryFeeOrThrow()). */
  private handleCountryChange() {
    const me = this;
    if (me.serviceId === WebShopMode.Retail) {
      me._webShopService.orderDataCountryChanged$
        .pipe(takeUntil(me._destroy$))
        .subscribe((changed) => {
          if (!changed) {
            return;
          }
          // re-read fresh — deliveryAddressViewModel is a stale snapshot from _initializeCustomerData()
          me.deliveryAddressViewModel = me._webShopService.getDelivaryAddress();
          const newCountry = me.deliveryAddressViewModel ? me.deliveryAddressViewModel.country : "";

          if (me.dynamicDataInputForm) {
            const countryControl = me.dynamicDataInputForm.get('country');
            if (countryControl) {
              countryControl.setValue(newCountry, { emitEvent: false });
            }
          }
          me.PushChanges();
        });
    }
  }

  // region Event Handlers

  public onFormStatusChange(isValid: boolean): void {
    this.PushChanges();
  }

  public onDeliveryAddressChange(addressId: string) {
    const me = this;
    me.deliveryAddressId = addressId;
    me.panelOpenState = addressId === me.DELIVERY_ADDRESS_ID;
    me.PushChanges();
  }

  /** Toggles DeliveryAddress View
   * currently used by ParentComponent to close View when navigating back
   * ideally should be removed and made into it's own component that the parent manages
   * instead of nested Views
   */
  public toggleBillingInfo(enable: boolean) {
    this.showBillingInfo = enable;
    this.PushChanges();
  }

  /**
 * Event handler when dynamicFormFields component is ready
 * Applies disabled states to fields based on business rules (e.g. country for Retail)
 */
  public async onDynamicFormReady(): Promise<void> {
    const me = this;
    if (!me.currentDynamicFormComponent) return;
    // for guest users
    if (!me.isRegistered && me.showBillingInfo) {
      await me.loadBillingAddressFromCache();
    }

    const isFurtherAddress = !me.showBillingInfo;
    const formData = me.showBillingInfo
      ? me.billingFormInitialData
      : me.isRegistered
        ? me.registeredUserDeliveryFormInitialData
        : me.guestDeliveryFormInitialData;

    me.currentDynamicFormComponent.formGroup.patchValue(formData, { emitEvent: false });
    me.applyFieldDisabledStates(isFurtherAddress);
    me.PushChanges();
  }

  // region Business Logic

  public isFieldDisabled(model: CustomerInputFieldViewModel, isFurtherAddress: boolean) {
    const me = this;
    const isDelivery = me.serviceId === WebShopMode.Delivery;
    const isDeliveryGroup = me.serviceId === WebShopMode.DeliveryGroup;
    const isRetail = me.serviceId === WebShopMode.Retail;

    const isPreselectedCountry = (model.fieldName === "country");
    const isPreselectedZIP = (model.fieldName === "zip_code");
    const isPreselectedCity = (model.fieldName === "city" && me._webShopService.DestinationCity !== "");
    const isPreselectedAddress = me._webShopService.PolygonMapInformation && (model.fieldName === "address" && me._webShopService.DestinationAddress !== "");

    if (isFurtherAddress) {
      if (isDelivery || isDeliveryGroup) {
        return (isPreselectedZIP || isPreselectedCity || isPreselectedAddress) ? true : null;
      } else if (isRetail) {
        return isPreselectedCountry ? true : null;
      }
    } else {
      if (!me.isRegistered) {
        if (isDelivery || isDeliveryGroup) {
          return (isPreselectedZIP || isPreselectedCity || isPreselectedAddress) ? true : null;
        } else if (isRetail) {
          return isPreselectedCountry ? true : null;
        }
      }
    }
    return null;
  }

  public async onConfirmOrderData() {
    const me = this;
    // Form validation
    if (me.currentDynamicFormComponent) {
      if (!me.currentDynamicFormComponent.formGroup.valid) {
        // mark all fields as touched to show validation errors
        Object.keys(me.currentDynamicFormComponent.formGroup.controls).forEach(key => {
          me.currentDynamicFormComponent.formGroup.controls[key].markAsTouched();
        });
        me.PushChanges();
        return;
      }
      // load data from input form
      const formData = me.currentDynamicFormComponent.getDynamicFieldsInput();
      Object.assign(me.webshopOrderDataViewModel, formData);
    }
    me._webShopService.setOrderDataViewModel(me.webshopOrderDataViewModel);

    try {
      await me._saveBillingInfo();
    } catch (error) {
      me._coreLogService.error("CustomerDataComponent.onConfirmOrderData", "_saveBillingInfo", error);
      me._snackBarService.ShowErrorMessageFailed(132);
      return;
    }

    if (me.needDeliveryAddress) {
      if (me.isRegistered) {
        me.createFurtherAddressList(me.webshopOrderDataViewModel);
        me.showBillingInfo = false;
        me.PushChanges();
      } else {
        me.getAndHandleGuestBillingAddress();
        me.verifyAndAssignGuestDeliveryAddress();
      }
    } else {
      me._webShopService.getWebshopSettingsDataModel().then(() => {
        me.openCheckout();
      });
    }
  }

  /**save billing info before checkout */
  private async _saveBillingInfo(): Promise<void> {
    const me = this;
    if (me.isRegistered) {
      await me._webShopService.setCustomerMainAddressDataModel(me.webshopOrderDataViewModel, me.customerInputFieldViewModels);
    }
  }

  /** set delivery address to service in deliveryAddressViewModel
   * Delivery / Retail > some fields are pre filled and disabled & Billing address used as delivery address
   * Takeaway / Ticket > Billing address used as delivery address
   * Webvoucher > Billing address is required and different delivery address can be entered
  */
  public async setGuestDeliveryAddress() {
    const me = this;

    // Early return: User selected billing address
    if (me.deliveryAddressId === me.BILLING_ADDRESS_ID) {
      me.verifyCurrentAddress();
      return;
    }
    // Early return: User did not select new delivery address
    if (me.deliveryAddressId !== me.DELIVERY_ADDRESS_ID) {
      me.verifyCurrentAddress();
      return;
    }

    // Load delivery address from form
    if (me.currentDynamicFormComponent) {
      const formData = me.currentDynamicFormComponent.getDynamicFieldsInput();
      Object.assign(me.guestDeliveryAddressViewModel, formData);
    }

    // Check if delivery address has data
    if (!me.hasAddressData(me.guestDeliveryAddressViewModel)) {
      me.deliveryAddressId = me.BILLING_ADDRESS_ID;
      me.verifyCurrentAddress();
      return;
    }

    // Check if delivery address is identical to billing address
    if (me.isSameAddress(me.guestDeliveryAddressViewModel, me.webshopOrderDataViewModel)) {
      me.deliveryAddressId = me.BILLING_ADDRESS_ID;
      me.verifyCurrentAddress();
      return;
    }

    // Use different delivery address
    me.deliveryAddressViewModel = me.guestDeliveryAddressViewModel;
    me.verifyCurrentAddress();
  }

  /**
   * setDelivery address to service in deliveryAddressViewModel
   * check if deliveryaddress is valid
   */
  public setRegisterdUserDeliveryAddress() {
    const me = this;
    if (me.deliveryAddressId !== me.BILLING_ADDRESS_ID) {
      if (me.deliveryAddressId !== me.DELIVERY_ADDRESS_ID) {
        const furtherAddresses = me.webshopOrderDataViewModel.furtherAddresses.find(a => a.id === me.deliveryAddressId);
        me.deliveryAddressViewModel = furtherAddresses;
      } else {
        if (me.currentDynamicFormComponent) {
          const formData = me.currentDynamicFormComponent.getDynamicFieldsInput();
          Object.assign(me.newDeliveryAddressViewModel, formData);
        }
        me.deliveryAddressViewModel = me.newDeliveryAddressViewModel;
      }
      me._webShopService.setDeliveryAddress(me.deliveryAddressViewModel);
    }

    const addressModel = me.deliveryAddressId === me.BILLING_ADDRESS_ID
      ? me.webshopOrderDataViewModel
      : me.deliveryAddressViewModel;

    const { zip_code, city, address, country } = me.extractTrimmedAddressFields(addressModel);
    me.verifyDeliveryAddressAndHandleNavigation(zip_code, city, address, country);
  }


  /** Applies disabled state to form fields based on business rules */
  private applyFieldDisabledStates(isFurtherAddress: boolean = false): void {
    const me = this;
    if (!me.currentDynamicFormComponent) return;

    const fieldViewModels = isFurtherAddress
      ? me.addressInputFieldViewModels
      : me.customerInputFieldViewModels;

    if (!fieldViewModels) return;

    fieldViewModels.forEach(field => {
      const shouldDisable = me.isFieldDisabled(field, isFurtherAddress);
      const control = me.currentDynamicFormComponent.formGroup.get(field.fieldName);
      if (control) {
        if (shouldDisable) {
          control.disable();
        } else {
          control.enable();
        }
      }
    });
  }

  /**
   * Verifies the delivery address and handles navigation accordingly.
   */
  private verifyDeliveryAddressAndHandleNavigation(zip_code: string, city: string, address: string, country: string = "") {
    const me = this;

    if (me._webShopService.isDeliveryAddressDestinationAddress(zip_code, city, address)) {
      if (me._webShopService.isDeliveryAddressValid(zip_code, city, address, country, null)) {
        const useDeliveryAddress = me.deliveryAddressId !== me.BILLING_ADDRESS_ID;
        me.openCheckout(useDeliveryAddress);
      } else {
        me._bottomSheetHelperService.open(InvalidDeliveryAddressComponent, {
          panelClass: "mat-bottom-sheet-container--full-height"
        });
      }
    } else {
      let description = (me._webShopService.DestinationCity.length > 0) ? "phDeliverAddressNotDestination_ZipAndCity_Text" : "phDeliverAddressNotDestination_Zip_Text";
      description = me._coreLanguageService.value(description);
      description = description.replace("{zip}", me._webShopService.DestinationZipCode).replace("{city}", me._webShopService.DestinationCity);
      // TODO bei PolyMap im Standort und Nutzung der PolyMap muss die Adresse auch geprüft werden

      me._MatDialog.open(ErrorDialogComponent, {
        data: {
          title: "phDeliverAddressNotDestination_Title"
          , description: description
        },
        panelClass: "error-dialog-styles"
      });
    }
  }

  /**
   * Determines if the current order mode is set to Delivery.
   * When true, the selected delivery address is fixed and cannot be changed.
   */
  public get isOrderDelivery(): boolean {
    const me = this;
    return me.serviceId === WebShopMode.Delivery;
  }

  private getAndHandleGuestBillingAddress() {
    const me = this;
    // load billing address
    const billingAddress = me.extractTrimmedAddressFields(me.webshopOrderDataViewModel);
    const zip = billingAddress.zip_code;
    const city = billingAddress.city;
    const address = billingAddress.address;
    const country = billingAddress.country;
    if (me._webShopService.isDeliveryAddressValid(zip, city, address, country, null)) {
      me.showBillingInfo = false;
    } else {
      me._bottomSheetHelperService.open(InvalidDeliveryAddressComponent, {
        panelClass: "mat-bottom-sheet-container--full-height"
      });
    }
  }

  private openCheckout(useDeliveryAddress: boolean = false) {
    const me = this;
    me.onContinue.emit(useDeliveryAddress);
  }

  public onAddressCheckBoxSelect(event: MatCheckboxChange): void {
    const addresscheckBoxListEle = Array.from(document.getElementsByClassName(".mat-checkbox input"));
    if (event.checked) {
      addresscheckBoxListEle.forEach(element => {
        element["checked"] = true;
      });
    } else {
      addresscheckBoxListEle.forEach(element => {
        element["checked"] = false;
      });
    }
  }

  /** Verifies and assigns the delivery address for the guest user
   * !Currently, only one address is used for delivery
   */
  private async verifyAndAssignGuestDeliveryAddress() {
    const me = this;
    if (me.serviceId === WebShopMode.Delivery) {
      let currentlyUsedAddress: IAddress = null;
      currentlyUsedAddress = await me.loadDeliveryAddressFromStorage();
      //Different delivery address, since the destination is write-protected there.
      me.deliveryAddressId = me.DELIVERY_ADDRESS_ID;
      let zip = me.trimValue(currentlyUsedAddress.zip_code);
      let city = me.trimValue(currentlyUsedAddress.city);
      let address = me.trimValue(currentlyUsedAddress.address);
      const isBillingAddressDestination =
        me.hasValue(me.webshopOrderDataViewModel.zip_code) && me.webshopOrderDataViewModel.zip_code === zip &&
        me.hasValue(me.webshopOrderDataViewModel.city) && me.webshopOrderDataViewModel.city === city &&
        me.hasValue(me.webshopOrderDataViewModel.address) && me.webshopOrderDataViewModel.address === address;
      if (isBillingAddressDestination) {
        me.deliveryAddressId = me.DELIVERY_ADDRESS_ID;
      }

    } else {
      if (me.serviceId === WebShopMode.Retail) {
        // Country is preselected
        me.guestDeliveryAddressViewModel.country = me.webshopOrderDataViewModel.country;
      }
      me.deliveryAddressId = me.BILLING_ADDRESS_ID;
    }
  }

  // !optimize for better readability
  /**create address delivery list for user when user is logged in
   * disable adresses when invalid to deliver
  */
  private createFurtherAddressList(webshopOrderDataViewModel: WebshopOrderDataViewModel): void {
    const me = this;
    me.deliveryAddressList = new Array();
    // als erste wird die Rechnungsadresse angelegt
    let zip = webshopOrderDataViewModel.zip_code ? webshopOrderDataViewModel.zip_code.trim() : "";
    let city = webshopOrderDataViewModel.city ? webshopOrderDataViewModel.city.trim() : "";
    let address = webshopOrderDataViewModel.address ? webshopOrderDataViewModel.address.trim() : "";
    if (me._webShopService.isDeliveryAddressDestinationAddress(zip, city, address)) {
      me.deliveryAddressList.push({ key: `${address}, ${zip} ${city}`, value: me.BILLING_ADDRESS_ID });
    } else {
      me.deliveryAddressList.push({ key: `${address}, ${zip} ${city}`, value: "disabled" });
    }
    // danach die gespeicherten Leiferadressen aufgelistet
    if (webshopOrderDataViewModel.furtherAddresses && webshopOrderDataViewModel.furtherAddresses.length > 0) {
      webshopOrderDataViewModel.furtherAddresses.forEach(furtherAddress => {
        zip = furtherAddress.zip_code ? furtherAddress.zip_code.trim() : "";
        city = furtherAddress.city ? furtherAddress.city.trim() : "";
        address = furtherAddress.address ? furtherAddress.address.trim() : "";
        if (me._webShopService.isDeliveryAddressDestinationAddress(zip, city, address)) {
          me.deliveryAddressList.push({ key: `${address}, ${zip} ${city}`, value: furtherAddress.id });
        } else {
          me.deliveryAddressList.push({ key: `${address}, ${zip} ${city}`, value: "disabled" });
        }
      });
    }

    if (me.addressInputFieldViewModels && me.addressInputFieldViewModels.length > 0) {
      me.deliveryAddressList.push({ key: "Add New Address", value: me.DELIVERY_ADDRESS_ID });
    }

    if (webshopOrderDataViewModel.furtherAddresses && webshopOrderDataViewModel.furtherAddresses.find(m => m.selected)) {
      me.deliveryAddressId = me.webshopOrderDataViewModel.furtherAddresses.find(m => m.selected).id;
    } else if (me.newDeliveryAddressViewModel && me.newDeliveryAddressViewModel.selected) {
      me.deliveryAddressId = me.DELIVERY_ADDRESS_ID;
    } else {
      // wenn default=0 ist, ermitteln ob eine Adresse zur gewählten Lieferadresse der Bestellung passt
      // wenn ja, diese Selectieren und die default wenn sie nicht passt disablen
      // Lieferadresse muss mit der Destination Adresse übereinstimmen, weil liefer gebühren anfallen können.
      if (me.serviceId === WebShopMode.Delivery || me.serviceId === WebShopMode.DeliveryGroup) {
        me.deliveryAddressId = me.DELIVERY_ADDRESS_ID; // inital Abweichende Lieferadresse, da die Destination dort schreibgeschuetzt ist
        let zip = me.trimValue(webshopOrderDataViewModel.zip_code);
        let city = me.trimValue(webshopOrderDataViewModel.city);
        let address = me.trimValue(webshopOrderDataViewModel.address);
        if (me._webShopService.isDeliveryAddressDestinationAddress(zip, city, address))
          me.deliveryAddressId = me.BILLING_ADDRESS_ID; // rechnungsadresse kann lieferadresse sein
        else if (webshopOrderDataViewModel.furtherAddresses && webshopOrderDataViewModel.furtherAddresses.length > 0) {
          // Selektieren der ersten Lieferadresse die zut Destination Adresse passt
          webshopOrderDataViewModel.furtherAddresses.forEach(furtherAddress => {
            zip = furtherAddress.zip_code ? furtherAddress.zip_code.trim() : "";
            city = furtherAddress.city ? furtherAddress.city.trim() : "";
            address = furtherAddress.address ? furtherAddress.address.trim() : "";
            if (me._webShopService.isDeliveryAddressDestinationAddress(zip, city, address)) {
              me.deliveryAddressId = furtherAddress.id;
              return false; // break foreach
            } // else continue search
            return true;
          });
        }
      } else {
        me.deliveryAddressId = me.BILLING_ADDRESS_ID; // bleibe bei Rechnungsadresse
      }
    }
    me.onDeliveryAddressChange(me.deliveryAddressId); // öffne eingabefelder, wenn abweichende Lieferadresse
  }

  // region Storage

  /** Retrieves delivery address fields from local storage */
  private async loadDeliveryAddressFromStorage() {
    const me = this;
    const keys = [LocalKeys.deliveryPostCode, LocalKeys.deliveryCity, LocalKeys.deliveryStreet, LocalKeys.houseNumber];
    const [deliveryPostCode, deliveryCity, deliveryStreet, houseNumber] = await Promise.all(
      keys.map(key => me._coreComService.environment.valueStorage.get(StorageHive.Local, key))
    );
    let deliveryAddress: IAddress = null;
    const hasAddressInLocalStorage = [deliveryPostCode, deliveryCity, deliveryStreet, houseNumber].every(me.hasValue);
    if (hasAddressInLocalStorage) {
      deliveryAddress = {
        zip_code: deliveryPostCode,
        city: deliveryCity,
        address: deliveryStreet + ' ' + houseNumber,
      };
    }
    me.PushChanges();
    return deliveryAddress;
  }

  /** loads cached delivery address from LocalStorage for guest users*/
  private async loadBillingAddressFromCache(): Promise<void> {
    const me = this;
    // Only load cache for Delivery modes where delivery address is pre-selected
    const shouldLoadCache = me.serviceId === WebShopMode.Delivery;
    if (!shouldLoadCache) {
      return;
    }

    const hasExistingData = me.webshopOrderDataViewModel && (
      me.hasValue(me.webshopOrderDataViewModel.zip_code) ||
      me.hasValue(me.webshopOrderDataViewModel.city) ||
      me.hasValue(me.webshopOrderDataViewModel.address)
    );
    if (hasExistingData) {
      return;
    }
    const cachedAddress = await me.loadDeliveryAddressFromStorage();
    if (cachedAddress && me.webshopOrderDataViewModel) {
      me.webshopOrderDataViewModel.zip_code = cachedAddress.zip_code;
      me.webshopOrderDataViewModel.city = cachedAddress.city;
      me.webshopOrderDataViewModel.address = cachedAddress.address;
      if (cachedAddress.country) {
        me.webshopOrderDataViewModel.country = cachedAddress.country;
      }
    }
  }


  // region Helper

  /**
 * Create form initial data from a data model and field models
 * @param dataToLoad - The data model (WebshopOrderDataViewModel or FurtherAddressViewModel)
 * @param fieldModels - The field configuration models
 * @returns Form data object with field names as keys
 */
  private createFormInitialData(
    dataToLoad: WebshopOrderDataViewModel | FurtherAddressViewModel | null,
    fieldModels: CustomerInputFieldViewModel[] | null
  ): { [key: string]: string | number | null } {
    if (!dataToLoad || !fieldModels) return {};

    const formData: { [key: string]: string | number | null } = {};
    fieldModels.forEach(field => {
      const value = dataToLoad[field.fieldName];
      formData[field.fieldName] = value || '';
    });

    return formData;
  }

  /** Content is not empty */
  public hasValue(value: string): boolean {
    return !Utils.IsNullOrEmpty(value);
  }

  private trimValue(value?: string): string {
    return value ? value.trim() : "";
  }

  private isSameAddress(guestAddress: FurtherAddressViewModel, webshopAddress: WebshopOrderDataViewModel): boolean {
    const me = this;
    return (
      me.trimValue(guestAddress.zip_code) === me.trimValue(webshopAddress.zip_code) &&
      me.trimValue(guestAddress.city) === me.trimValue(webshopAddress.city) &&
      me.trimValue(guestAddress.address) === me.trimValue(webshopAddress.address)
    );
  }

  private verifyCurrentAddress() {
    const me = this;
    const model =
      me.deliveryAddressId === me.BILLING_ADDRESS_ID
        ? me.webshopOrderDataViewModel
        : me.deliveryAddressViewModel;

    me.verifyDeliveryAddressAndHandleNavigation(
      me.trimValue(model.zip_code),
      me.trimValue(model.city),
      me.trimValue(model.address),
      me.trimValue(model.country),
    );
  }

  private hasAddressData(address: FurtherAddressViewModel | null): boolean {
    const me = this;
    return address && (
      me.hasValue(address.zip_code) ||
      me.hasValue(address.city) ||
      me.hasValue(address.address)
    );
  }

  /** Extracts and trims address fields from address model*/
  private extractTrimmedAddressFields(addressModel: WebshopOrderDataViewModel | FurtherAddressViewModel) {
    const me = this;
    let address: IAddress = null;
    if (addressModel) {
      address = {
        zip_code: me.trimValue(addressModel.zip_code),
        city: me.trimValue(addressModel.city),
        address: me.trimValue(addressModel.address),
        country: me.trimValue(addressModel.country)
      }
    }
    return address;
  }

  /** Creates FurtherAddressViewModel from stored address data */
  private createFurtherAddressFromStorage(storedAddress: IAddress): FurtherAddressViewModel {
    const model = new FurtherAddressViewModel();
    model.zip_code = storedAddress.zip_code;
    model.city = storedAddress.city;
    model.address = storedAddress.address;
    if (storedAddress.country) {
      model.country = storedAddress.country;
    }
    return model;
  }

  /** Retrieves the label for the guest billing address.*/
  public getGuestBillingAddressLabel() {
    const me = this;
    // load billing address
    const billingAddress = me.extractTrimmedAddressFields(me.webshopOrderDataViewModel);
    if (billingAddress) {
      const label = me._coreLanguageService.value("phOrderData_CurrentlyUsedBillingAddress")
        .replace("{address}", billingAddress.address)
        .replace("{zip}", billingAddress.zip_code)
        .replace("{city}", billingAddress.city);
      return label;
    }
  }

  /** Retrieves the label for the guest delivery address. */
  private async getGuestDeliveryAddressLabel(): Promise<void> {
    const me = this;
    let currentlyUsedAddress: IAddress = null;
    currentlyUsedAddress = await me.loadDeliveryAddressFromStorage();
    if (currentlyUsedAddress) {
      me.guestDeliveryAddressLabel = me._coreLanguageService.value("phOrderData_CurrentlyUsedDeliveryAddress")
        .replace("{address}", currentlyUsedAddress.address)
        .replace("{zip}", currentlyUsedAddress.zip_code)
        .replace("{city}", currentlyUsedAddress.city);
      me.PushChanges();
    }
  }

  // region Navigation
  public navigateToRegister(): void {
    const me = this;
    me._navigateToRegistration(RegetrationTab.Register);
  }

  public navigateToLogin(): void {
    const me = this;
    me._navigateToRegistration(RegetrationTab.Login);
  }

  private _navigateToRegistration(tabIndex: number): void {
    const me = this;
    me._routerHelperService.setRouteTargetDataByKey("returnUrl", me._router.routerState.snapshot.url);
    me._routerHelperService.setRouteTargetDataByKey("tabIndex", tabIndex);
    me._router.navigateByUrl("/registration");
  }

  //!temporarily for these customers only CDS 20429, Bavaria Alm 21479, Vapiano 31917 & Lewenslust 26320
  /** Determines whether to hide the alternate delivery address option based on specific customer numbers. */
  public shouldHideAlternateDeliveryAddress(): boolean {
    const me = this;
    let hideSelection: boolean = false;
    const isWebVoucher = me.serviceId === WebShopMode.Webvoucher;
    if (isWebVoucher) {
      hideSelection = env.HypCusNumber === 20429 || env.HypCusNumber === 21479 || env.HypCusNumber === 31917 || env.HypCusNumber === 26320;
    }
    return hideSelection;
  }
}
